/** Compact pulsating NEXUS orb for chat loading states. */
export default function NexusThinkingOrb({ landing = false, size = "md" }) {
  return (
    <div
      className={`nexus-thinking-orb nexus-thinking-orb--${size} ${landing ? "nexus-thinking-orb--landing" : ""}`}
      aria-hidden
    >
      <div className="nexus-thinking-orb-halo" />
      <div className="nexus-thinking-orb-energy nexus-thinking-orb-energy--1" />
      <div className="nexus-thinking-orb-energy nexus-thinking-orb-energy--2" />
      <div className="nexus-thinking-orb-glow" />
      <div className="nexus-thinking-orb-core">
        <div className="nexus-thinking-orb-core-shine" />
      </div>
    </div>
  );
}
